export default "__VITE_ASSET__DnshilBQ__"